export type IEventAttributes = Record<string, string | number | boolean>
export type IEvent = {
  event: string
  action?: string
  label?: string
  amount?: number
  attributes?: IEventAttributes
}

type IFullEvent = IEvent & {
  uid: string
  createdTime: number
}

let drainTimer: NodeJS.Timeout
let drainWaiting: boolean
const queue = {
  url: process.env.EVENT_QUEUE || 'https://events.sellwild.com/events/queue',
  // url: 'http://localhost:8009/events/queue',
  debug: false,//true,
  running: false,
  interval: 10000,
  max: 100,
  events: [] as IFullEvent[],
  uid: '',
}


function makeUid () {
  try {
    if (typeof window !== 'undefined' && typeof window.crypto === 'object' && 'randomUUID' in window.crypto) {
      return (window.crypto as any).randomUUID()
    }
  } catch {}
  
  return 'unkown'
}

/** The reader's stored id: the events queue's, and the one feed A/B tests split readers on. */
export function getUid () {
  if (queue.uid) return queue.uid

  queue.uid = localStorage.getItem('_sw_uid') || ''

  if (!queue.uid) {
    queue.uid = makeUid()
    localStorage.setItem('_sw_uid', queue.uid)
  }
  
  return queue.uid
}

export function pushEventNow (event: IEvent) {
  pushEvent(event)
  drainQueue()
}
export function pushEvent (event: IEvent) {
  const full = {
    ...event,
    uid: getUid(),
    createdTime: Date.now()
  }

  queue.events.push(full)

  if (queue.debug) {
    console.log('Pushed event', full)
  }

  runQueue()
  initDrainEventsOnce({})
}

const pushEventOnce = (base: IEvent) => once<Partial<IEvent>, void>((event) => pushEvent({ ...base, ...event }))
const pushEventOnceNow = (base: IEvent) => once<Partial<IEvent>, void>((event) => pushEventNow({ ...base, ...event }))

const initDrainEventsOnce = once(() => {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === "hidden") {
      drainQueue()
    }
  })
})

export const pushFirstAdViewed = pushEventOnce({ event: 'firstAdViewed' })
export const pushCustomElementsNotSupported = pushEventOnceNow({ event: 'customElementsNotSupported' })

function runQueue () {
  if (queue.events.length >= queue.max) {
    drainQueue()
  } else if (!drainWaiting) {
    drainWaiting = true
    drainTimer = setTimeout(() => {
      drainQueue()
    }, queue.interval)
  }
}

function drainQueue () {
  drainWaiting = false
  clearTimeout(drainTimer)
  const events = queue.events.splice(0, queue.max)

  if (events.length) {
    if (queue.debug) {
      console.log("SEND TO ANALYTICS", events)
    } else if (typeof window.navigator.sendBeacon === 'function') {
      window.navigator.sendBeacon(queue.url, JSON.stringify(events))
    } else {
      return fetch(queue.url, {
        method: 'POST',
        body: JSON.stringify(events),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .catch(() => {
        queue.events.push(...events)
      })
    }
  }
}

function once<V = unknown, O = unknown>(fn: (v: V) => O) {
  const calledMap: Record<string, boolean> = {}
  
  return (v: V, id: string = '__default__') => {
    if (!calledMap[id]) {
      calledMap[id] = true
      return fn(v)
    }
  }
}

function throttle (fn: () => void, n = 0) {

}